import { render, staticRenderFns } from "./ActionsBlock.vue?vue&type=template&id=5af17ee6&"
import script from "./ActionsBlock.vue?vue&type=script&lang=ts&"
export * from "./ActionsBlock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports